import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { GetDocumentCentreConfigResponse, SaveDocumentCentreConfigResponse, SaveDocumentCentreConfigRequest } from '@admin/models/document-centre-config';

@Injectable({ providedIn: 'root' })
export class DocumentCentreConfigHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilder: UrlBuilderService) {
  }

  getDocumentCentreConfig(): Observable<GetDocumentCentreConfigResponse> {
    const url = this.urlBuilder.getUrl(`document-centre/system-config`);
    return this
      .http
      .get<GetDocumentCentreConfigResponse>(url);
  }

  saveDocumentCentreConfig(request: SaveDocumentCentreConfigRequest): Observable<SaveDocumentCentreConfigResponse> {
    const url = this.urlBuilder.getUrl(`document-centre/system-config`);
    return this
      .http
      .post<SaveDocumentCentreConfigResponse>(url, request);
  }

}
